"use client"

import css from "./MainScene.module.scss"
import { useHover } from 'usehooks-ts'
import { useEffect, useRef, useState } from "react"
import { usePathname } from "next/navigation"
import { useRouter } from "next/navigation"

export const ErrorScene = ({
    styles = {},
    hoverItem,
    setHoverItem
}) => {
    const [screenWidth, setScreenWidth] = useState(0)
    const pathname = usePathname()
    const [align, setAlign] = useState("right")
    const router = useRouter()

    const forFarmersRef = useRef(null)
    const productsRef = useRef(null)
    const consultingRef = useRef(null)
    const LKRef = useRef(null)
    const tradingRef = useRef(null)
    const exportRef = useRef(null)

    const isHoverForFarmers = useHover(forFarmersRef)
    const isHoverProducts = useHover(productsRef)
    const isHoverConsulting = useHover(consultingRef)
    const isHoverLK = useHover(LKRef)
    const isHoverTrading = useHover(tradingRef)
    const isHoverExport = useHover(exportRef)

    useEffect(() => {
        isHoverForFarmers == false ? setHoverItem(0) : setHoverItem(1)
    }, [isHoverForFarmers])
    useEffect(() => {
        isHoverProducts == false ? setHoverItem(0) : setHoverItem(3)
    }, [isHoverProducts])
    useEffect(() => {
        isHoverConsulting == false ? setHoverItem(0) : setHoverItem(4)
    }, [isHoverConsulting])
    useEffect(() => {
        isHoverLK == false ? setHoverItem(0) : setHoverItem(5)
    }, [isHoverLK])
    useEffect(() => {
        isHoverTrading == false ? setHoverItem(0) : setHoverItem(6)
    }, [isHoverTrading])
    useEffect(() => {
        isHoverExport == false ? setHoverItem(0) : setHoverItem(7)
    }, [isHoverExport])

    useEffect(() => {
        pathname !== "/" || pathname !== "/testing"
            ?
            setAlign("left")
            :
            setAlign("right")

        const updateScreenWidth = () => setScreenWidth(window.innerWidth)
        updateScreenWidth()
        window.addEventListener("resize", updateScreenWidth)
        return () => window.removeEventListener("resize", updateScreenWidth)
    }, [])

    return (
        <div
            style={
                screenWidth > 677 ?
                    align == "right" ?
                        { ...styles, position: "relative", display: "flex", justifyContent: "flex-end", alignItems: "center" }
                        :
                        { ...styles, position: "relative", display: "flex", justifyContent: "flex-start", alignItems: "center" }
                    :
                    { ...styles, position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }
            }
        >
            <img
                src="/mainScene/default.webp"
                style={hoverItem == 0 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                className={css.img} />
            <img
                src="/mainScene/for_farmers.webp"
                style={hoverItem == 1 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                className={css.img} />
            <div
                onClick={() => { router.push("/for-farmers") }}
                ref={forFarmersRef}
                style={{ width: 223, height: 169, right: 822, top: "15%", position: "absolute", background: "black", zIndex: 2, opacity: 0, cursor: "pointer" }}></div>
            <img
                src="/mainScene/default.webp"
                style={hoverItem == 2 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                className={css.img} />
            <img
                src="/mainScene/products.webp"
                style={hoverItem == 3 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                className={css.img} />
            <div
                onClick={() => { router.push("/products") }}
                ref={productsRef}
                style={{ width: 253, height: 189, right: 601, top: "42%", position: "absolute", background: "black", zIndex: 2, opacity: 0, cursor: "pointer" }}>
            </div>
            <img
                src="/mainScene/consulting.webp"
                style={hoverItem == 4 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                className={css.img} />
            <div
                onClick={() => { router.push("/consulting") }}
                ref={consultingRef}
                style={{ width: 83, height: 119, right: 818, top: "37%", position: "absolute", background: "black", zIndex: 2, opacity: 0, cursor: "pointer" }}></div>
            <img
                src="/mainScene/lk.webp"
                style={hoverItem == 5 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                className={css.img} />
            <div
                onClick={() => { router.push("/labs") }}
                ref={LKRef}
                style={{ width: 83, height: 119, right: 508, top: "40%", position: "absolute", background: "black", zIndex: 2, opacity: 0, cursor: "pointer" }}>
            </div>
            <img
                src="/mainScene/trading.webp"
                style={hoverItem == 6 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                className={css.img} />
            <div
                onClick={() => { router.push("/trading") }}
                ref={tradingRef}
                style={{ width: 183, height: 189, right: 332, top: "37%", position: "absolute", background: "black", zIndex: 2, opacity: 0, cursor: "pointer" }}>
            </div>
            <img
                src="/mainScene/export.webp"
                style={hoverItem == 7 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                className={css.img} />
            <div
                onClick={() => { router.push("/export") }}
                ref={exportRef}
                style={{ width: 183, height: 139, right: 153, top: "37%", position: "absolute", background: "black", zIndex: 2, opacity: 0, cursor: "pointer" }}>
            </div>
        </div>
    )
}

const MainScene = ({
    styles = {},
    hoverItem,
    setHoverItem
}) => {
    const [screenWidth, setScreenWidth] = useState(0)
    const pathname = usePathname()
    const [align, setAlign] = useState("left")
    const router = useRouter()

    const forFarmersRef = useRef(null)
    const productsRef = useRef(null)
    const consultingRef = useRef(null)
    const LKRef = useRef(null)
    const tradingRef = useRef(null)
    const exportRef = useRef(null)

    const isHoverForFarmers = useHover(forFarmersRef)
    const isHoverProducts = useHover(productsRef)
    const isHoverConsulting = useHover(consultingRef)
    const isHoverLK = useHover(LKRef)
    const isHoverTrading = useHover(tradingRef)
    const isHoverExport = useHover(exportRef)

    useEffect(() => {
        isHoverForFarmers == false ? setHoverItem(0) : setHoverItem(1)
    }, [isHoverForFarmers])
    useEffect(() => {
        isHoverProducts == false ? setHoverItem(0) : setHoverItem(3)
    }, [isHoverProducts])
    useEffect(() => {
        isHoverConsulting == false ? setHoverItem(0) : setHoverItem(4)
    }, [isHoverConsulting])
    useEffect(() => {
        isHoverLK == false ? setHoverItem(0) : setHoverItem(5)
    }, [isHoverLK])
    useEffect(() => {
        isHoverTrading == false ? setHoverItem(0) : setHoverItem(6)
    }, [isHoverTrading])
    useEffect(() => {
        isHoverExport == false ? setHoverItem(0) : setHoverItem(7)
    }, [isHoverExport])

    useEffect(() => {
        pathname !== "/" || pathname !== "/testing"
            ?
            setAlign("left")
            :
            setAlign("right")

        const updateScreenWidth = () => setScreenWidth(window.innerWidth)
        updateScreenWidth()
        window.addEventListener("resize", updateScreenWidth)
        return () => window.removeEventListener("resize", updateScreenWidth)
    }, [])

    return (
        <div
            style={
                screenWidth > 677 ?
                    align == "right" ?
                        { ...styles, position: "relative", display: "flex", justifyContent: "flex-end", alignItems: "center" }
                        :
                        { ...styles, position: "relative", display: "flex", justifyContent: "flex-start", alignItems: "center" }
                    :
                    { ...styles, position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }
            }
        >
            {pathname == "/" || pathname == "/testing" || pathname == "/b2b" || pathname == "/about-us" || pathname == "/school" ?
                <>
                    <img
                        src="/mainScene/default.webp"
                        style={hoverItem == 0 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                        className={css.img} />
                    <img
                        src="/mainScene/for_farmers.webp"
                        style={hoverItem == 1 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                        className={css.img} />
                    <div
                        onClick={() => { router.push("/for-farmers") }}
                        ref={forFarmersRef}
                        style={{ width: 223, height: 169, right: 822, top: "15%", position: "absolute", background: "black", zIndex: 2, opacity: 0, cursor: "pointer" }}></div>
                    <img
                        src="/mainScene/default.webp"
                        style={hoverItem == 2 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                        className={css.img} />
                    <img
                        src="/mainScene/products.webp"
                        style={hoverItem == 3 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                        className={css.img} />
                    <div
                        onClick={() => { router.push("/products") }}
                        ref={productsRef}
                        style={{ width: 253, height: 189, right: 601, top: "42%", position: "absolute", background: "black", zIndex: 2, opacity: 0, cursor: "pointer" }}>
                    </div>
                    <img
                        src="/mainScene/consulting.webp"
                        style={hoverItem == 4 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                        className={css.img} />
                    <div
                        onClick={() => { router.push("/consulting") }}
                        ref={consultingRef}
                        style={{ width: 83, height: 119, right: 818, top: "37%", position: "absolute", background: "black", zIndex: 2, opacity: 0, cursor: "pointer" }}></div>
                    <img
                        src="/mainScene/lk.webp"
                        style={hoverItem == 5 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                        className={css.img} />
                    <div
                        onClick={() => { router.push("/labs") }}
                        ref={LKRef}
                        style={{ width: 83, height: 119, right: 508, top: "40%", position: "absolute", background: "black", zIndex: 2, opacity: 0, cursor: "pointer" }}>
                    </div>
                    <img
                        src="/mainScene/trading.webp"
                        style={hoverItem == 6 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                        className={css.img} />
                    <div
                        onClick={() => { router.push("/trading") }}
                        ref={tradingRef}
                        style={{ width: 183, height: 189, right: 332, top: "37%", position: "absolute", background: "black", zIndex: 2, opacity: 0, cursor: "pointer" }}>
                    </div>
                    <img
                        src="/mainScene/export.webp"
                        style={hoverItem == 7 ? { opacity: 1, position: "absolute" } : { opacity: 0, position: "absolute" }}
                        className={css.img} />
                    <div
                        onClick={() => { router.push("/export") }}
                        ref={exportRef}
                        style={{ width: 183, height: 139, right: 153, top: "37%", position: "absolute", background: "black", zIndex: 2, opacity: 0, cursor: "pointer" }}>
                    </div>
                </>
                : null}
            {pathname == "/for-farmers" ?
                <img src="/mainScene/for_farmers_detail.webp" style={{ opacity: 1, position: "absolute" }} className={css.img} />
                : null}
            {pathname == "/products" ?
                <img src="/mainScene/products_detail.webp" style={{ opacity: 1, position: "absolute" }} className={css.img} />
                : null}
            {pathname == "/consulting" ?
                <img src="/mainScene/consulting_detail.webp" style={{ opacity: 1, position: "absolute" }} className={css.img} />
                : null}
            {pathname == "/labs" ?
                <img src="/mainScene/lk_detail.webp" style={{ opacity: 1, position: "absolute" }} className={css.img} />
                : null}
            {pathname == "/trading" ?
                <img src="/mainScene/trading_detail.webp" style={{ opacity: 1, position: "absolute" }} className={css.img} />
                : null}
            {pathname == "/export" ?
                <img src="/mainScene/export_detail.webp" style={{ opacity: 1, position: "absolute" }} className={css.img} />
                : null}
        </div>
    )
}

export default MainScene